function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "PlusIcon_svg__a",
  d: "M5.833 14V8.166H0V5.833h5.833V0h2.333v5.833H14v2.333H8.167V14z"
});

function SvgPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _ref, _ref2);
}

export default SvgPlusIcon;